module.exports = __webpack_public_path__ + "img/hourglass-end.776f43ee.svg";